import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
// eslint-disable-next-line no-unused-vars
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'startdate', label: 'Start', sortable: true },
    { key: 'enddate', label: 'End', sortable: true },
    { key: 'mon', label: 'Month', sortable: true },
    { key: 'urut', label: 'Week', sortable: true },
    { key: 'ctpp', label: 'CTPP (%)', sortable: true },
    { key: 'service_level', label: 'Service Level (%)', sortable: true },
    { key: 'cpm_scm', label: 'Customer Complain (%)', sortable: true },
    { key: 'deviasi_stock', label: 'Deviasi Stock (%)', sortable: true },
    { key: 'productivity_scm', label: 'Productivity SCM (%)', sortable: true },
    { key: 'stock', label: 'Stock Fitting (Ton)', sortable: true },
    { key: 'outsp', label: 'Out Of Stock SP (%)', sortable: true },
    { key: 'outfg', label: 'Out Of Stock FG (SKU)', sortable: true },
    { key: 'pic_scm', label: 'Update By', sortable: true },
    { key: 'scm_update_date', label: 'Update Date', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalData = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('startdate')
  const isSortDirDesc = ref(true)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalData.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchData = (ctx, callback) => {
    store
      .dispatch('app-user/fetchData', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        tanggal_to: planFilter.value,
        tanggal_from: statusFilter.value,
      })
      .then(response => {
        // const { users, total } = response.data

        callback(response.data.data)
        totalData.value = response.data.count
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching Data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        // refUserListTable.value.refresh()
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchData,
    tableColumns,
    perPage,
    currentPage,
    totalData,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    planFilter,
    statusFilter,
  }
}
